if (!customElements.get('stories-archive')) {
  class StoriesArchive extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('[data-stories-grid]');
      this.loadMoreButton = this.querySelector('[data-stories-load-more]');
      this.sortSelect = this.querySelector('[data-stories-sort]');
      this.sectionId = this.dataset.sectionId;
      this.sortOrder = this.dataset.sort || 'latest';
      this.displayLimit = Number(this.dataset.limit || 0);

      this.onLoadMore = this.onLoadMore.bind(this);
      this.onSortChange = this.onSortChange.bind(this);

      if (this.loadMoreButton) {
        this.loadMoreButton.addEventListener('click', this.onLoadMore);
      }

      if (this.sortSelect) {
        this.sortSelect.addEventListener('change', this.onSortChange);
      }

      this.applyDisplayLimit();
    }

    disconnectedCallback() {
      if (this.loadMoreButton) {
        this.loadMoreButton.removeEventListener('click', this.onLoadMore);
      }

      if (this.sortSelect) {
        this.sortSelect.removeEventListener('change', this.onSortChange);
      }
    }

    onSortChange(event) {
      this.sortOrder = event.target.value || 'latest';
      this.dataset.sort = this.sortOrder;
      this.sortArticles();
    }

    getSortValue(card, key) {
      if (key === 'title') {
        return (card.dataset.title || '').trim();
      }

      return Number(card.dataset[key] || 0);
    }

    compareCards(a, b) {
      switch (this.sortOrder) {
        case 'oldest':
          return this.getSortValue(a, 'published') - this.getSortValue(b, 'published');
        case 'title-asc':
          return this.getSortValue(a, 'title').localeCompare(this.getSortValue(b, 'title'));
        case 'title-desc':
          return this.getSortValue(b, 'title').localeCompare(this.getSortValue(a, 'title'));
        case 'updated':
          return this.getSortValue(b, 'updated') - this.getSortValue(a, 'updated');
        case 'latest':
        default:
          return this.getSortValue(b, 'published') - this.getSortValue(a, 'published');
      }
    }

    sortArticles() {
      if (!this.grid) return;

      const items = Array.from(this.grid.querySelectorAll('.stories-card'));
      items.sort((a, b) => this.compareCards(a, b));
      items.forEach((item) => this.grid.appendChild(item));
      this.applyDisplayLimit();
    }

    applyDisplayLimit() {
      if (!this.grid || !this.displayLimit || this.displayLimit < 1) return;

      const items = Array.from(this.grid.querySelectorAll('.stories-card'));
      items.forEach((item, index) => {
        item.hidden = index >= this.displayLimit;
      });
    }

    async onLoadMore() {
      const nextUrl = this.dataset.nextUrl;
      if (!nextUrl || !this.sectionId || !this.grid || !this.loadMoreButton) return;

      this.loadMoreButton.setAttribute('aria-busy', 'true');

      try {
        const url = new URL(nextUrl, window.location.origin);
        url.searchParams.set('section_id', this.sectionId);

        const response = await fetch(url.toString());
        if (!response.ok) throw new Error(`Failed to load stories (${response.status})`);

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const nextSection = doc.querySelector('stories-archive');
        if (!nextSection) throw new Error('Stories section not found in response');

        const nextCards = nextSection.querySelectorAll('[data-stories-grid] .stories-card');
        nextCards.forEach((card) => this.grid.appendChild(card));

        if (this.sortOrder !== 'latest') {
          this.sortArticles();
        } else {
          this.applyDisplayLimit();
        }

        const newNextUrl = nextSection.dataset.nextUrl;
        if (newNextUrl) {
          this.dataset.nextUrl = newNextUrl;
        } else {
          delete this.dataset.nextUrl;
          this.loadMoreButton.hidden = true;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loadMoreButton.removeAttribute('aria-busy');
      }
    }
  }

  customElements.define('stories-archive', StoriesArchive);
}
